import { render, staticRenderFns } from "./consent-ais-company-logs-tab.vue?vue&type=template&id=fb1f2f78&scoped=true"
import script from "./consent-ais-company-logs-tab.vue?vue&type=script&lang=js"
export * from "./consent-ais-company-logs-tab.vue?vue&type=script&lang=js"
import style0 from "./consent-ais-company-logs-tab.vue?vue&type=style&index=0&id=fb1f2f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1f2f78",
  null
  
)

export default component.exports